import { usePharmacyId } from '~shared/routes';

import { useSession } from './useSession';

export const useCurrentPharmacy = () => {
  const { session } = useSession(usePharmacyId());

  if (!session) {
    throw new Error('useCurrentPharmacy must be used under AuthenticatedRoute');
  }

  return session.pharmacy;
};
